import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentStatusReason } from './normalize';

export const fetchShipmentStatusReason = createProvider(api.fetchShipmentStatusReason)
  .andThen((res) => normalizeShipmentStatusReason(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
